import { render } from "./Modal.vue?vue&type=template&id=2720f4d3&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=2720f4d3&lang=less&scoped=true"

import exportComponent from "/Users/zhouti/Desktop/work/fy-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2720f4d3"]])

export default __exports__